// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qGdaF","left":"styles_left__1dYH7"};